import React from 'react'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'

const projects =[
  {
    title: "Sunrise Heights Residential Estate",
    photo: "/residentialestate.jpg",
    description: "A modern residential estate with 50 units, designed for comfort and sustainability, featuring green spaces and energy-efficient homes"
  },
  {
    title: "Unity Mall Commercial Complex",
    photo: "/unitymall.jpg",
    description: "A vibrant commercial complex with over 30 retail spaces, designed for community engagement and modern shopping experiences"
  },
  {
    title: "GreenLink Highway Bypass",
    photo: "/greenlink.jpg",
    description: "A major highway bypass project aimed at reducing traffic congestion, featuring eco-friendly design and advanced traffic management systems"
  },
  {
    title: "PZ Logistics Hub",
    photo: "/logisticshub.jpg",
    description: "A state-of-the-art logistics hub designed to streamline supply chain operations, featuring advanced warehousing and distribution facilities"
  },
  {
    title: " BuildSmart Consulting for Horizon Estate",
    photo: "/buildsmart.jpg",
    description: "A comprehensive consulting project for Horizon Estate, focusing on sustainable building practices and innovative design solutions"
  },
]

const SampleProjects = () => {
  return (
    <div className="bg-slate-200 text-gray-900 py-10">
      {/* Header Section */}
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className='max-w-7xl mx-auto text-center px-6 py-12'
      >
        <h1 className='text-5xl font-bold text-[#29313f] mb-6'>
          Built to Tell a Story
        </h1>

        <p className='text-lg text-gray-600 mb-8'>
        Explore the projects where vision meets precision — crafted with innovation, engineered for impact, and delivered with unmatched detail.
        </p>

        <Link to="/services">
          <button className='bg-[#29313f] text-white py-3 px-6 rounded-xl shadow-lg hover:bg-slate-300 transition-all duration-300'>
            See What We've Built 
          </button>
        </Link>
      </motion.section>

      {/* Projects grid section */}
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.2 }}
        className='max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-col-3 gap-8 px-6 py-12'
      >
        {projects.map((project, index) => {
          return (
            <motion.div
              key={index}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              viewport={{ once: true }}
              className='bg-white rounded-lg shadow-lg overflow-hidden transform transition-all hover:scale-105'
            >
              <img
                src={project.photo}
                alt={`THis is ${project.title}`}
                className='w-full h-48 object-cover'
              />

              <div className='p-6'>
                <h3 className='text-2xl font-semibold text-[#29313f] mb-4'>
                  {project.title}
                </h3>
                <p className='text-gray-600'>
                  {project.description}
                </p>
              </div>
            </motion.div>
          )
        })}

      </motion.section>

      {/* call to action section */}
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="bg-[#29313F] text-white py-12 px-6 text-center"
      >
        <h2 className='text-3xl font-semibold mb-4'>
          Partner in Possibility
        </h2>
        <p className='text-lg mb-8'>
          Got a project in mind? Let’s turn your vision into a landmark. Connect with us — and together, we’ll build something remarkable.
        </p>
        <Link to="/contactus">
          <button className="bg-white text-[#29313F] py-3 px-6 rounded-xl shadow-lg hover:bg-[#D1D5DB] hover:text-[#1D4ED8] transition-all duration-300">
            Start the Conversation
          </button>
        </Link>
      </motion.section>
    </div>
  )
}

export default SampleProjects